<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
					<el-form-item>
						<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">设备ID/Mac:</el-button>
					</el-form-item>				
	  				<el-form-item>
						<el-input placeholder="请输入内容" v-model="inputWhat" class="input-with-select" size="mini">
						    <el-select v-model="selectWhat" slot="prepend" placeholder="请选择">
							    <el-option label="设备ID" value="1"></el-option>
							    <el-option label="MAC地址" value="2"></el-option>
						    </el-select>
					    <el-button slot="append" @click="clearIDmac">清除</el-button>
					  	</el-input>
					</el-form-item>
<!--					<el-form-item>-->
<!--						<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">经销商:</el-button>-->
<!--					</el-form-item>-->
<!--					<el-form-item>-->
<!--						<el-cascader placeholder="请选择经销商" expand-trigger="hover" size="mini" :options="JXSareaList" v-model="chooseJxs" @change="changeJxs"></el-cascader>-->
<!--					</el-form-item>-->
				</el-form>
			<el-form :inline="true">
<!--				<el-form-item>-->
<!--    				<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">发货/销售时间:</el-button>-->
<!--					<el-select v-model="TypeTime" clearable placeholder="请选择日期类别" size="mini" style="width: 135px;">-->
<!--    					<el-option label="发货日期" value="1"></el-option>-->
<!--    					<el-option label="销售日期" value="2"></el-option>-->
<!--  					</el-select>-->
<!--					<el-date-picker v-model="ChooseTime" size="mini" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->
<!--				</el-form-item>-->
<!--    			<el-form-item>-->
<!--    				<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">发货区域:</el-button>-->
<!--    				<el-cascader size="mini" :options="Addoptions" v-model="AddrSelect" @change="SelectChange" filterable change-on-select clearable></el-cascader>	-->
<!--    			</el-form-item>-->
    			
			</el-form>
			<!--<el-form :inline=true>
				<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">经销商筛选:</el-button>
				<el-select v-model="ChooseJxs" multiple size="mini" placeholder="请选择">
    				<el-option-group v-for="group in JXSareaList" :key="group.label" :label="group.label">
      					<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    				</el-option-group>
  				</el-select>
			</el-form>-->
			<el-form :inline="true">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">累积量信息筛选：</el-button>
				</el-form-item>
				<el-form-item>
					<el-select v-model="selectMore" placeholder="筛选项" size="mini" style="width: 200px;">
	  					<el-option v-for="item in Choice" :label='item.name' :key='item.val' :value='item.val'></el-option>
					</el-select>
  				</el-form-item>
  				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">范围：</el-button>
				</el-form-item>
  				<el-form-item>
					<el-input type="number" v-model="input1" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">~</el-button>
				</el-form-item>
				<el-form-item>
					<el-input  type="number" v-model="input2" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" plain size="mini" @click="handleInputConfirm">添加条件 ↓</el-button>
				</el-form-item>
			</el-form>
			<el-form :inline="true" id="addMessage">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">筛选条件:</el-button>
				</el-form-item>
				<el-form-item>
					<div id="Addbox">
						<el-tag type="success" :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)" style="margin-right: 10px;" size="small">{{tag}}</el-tag>
					</div>
				</el-form-item>	
				<el-form-item >
					<el-button type="primary" plain size="mini" @click="Quickfind">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新页面</el-button>
				</el-form-item>
			</el-form>
			
			
		</el-col>
		
		 
		
		<el-table id="SportTableBox" :data="List" border v-loading="listloading" @filter-change="Filterfind" :row-class-name="tableRowClassName" style="width: 99.9%;" :max-height="maxHeight">
			<el-table-column fixed label="序号" width="50" prop="sNumber"></el-table-column>
			<el-table-column fixed label="设备ID" width="100" prop="did"></el-table-column>
			<el-table-column label="Mac地址" prop="mac" width="150"></el-table-column>
<!--			<el-table-column label="发货时间" width="100" prop="delivery_date" :formatter="dateFormat2"></el-table-column>-->
<!--			<el-table-column label="销售时间" width="100" prop="sales_date" :formatter="dateFormat2"></el-table-column>-->
			<el-table-column label="收货人" prop="receiver" width="130"></el-table-column>
			<el-table-column label="发货区域" prop="address" width="130" :formatter="addformat2"></el-table-column>
			<el-table-column label="发货地址" prop="address" width="300" :formatter="addformat"></el-table-column>
<!--			<el-table-column label="经销商" prop="dealer" width="250">-->
<!--				<template slot-scope="scope">-->
<!--					<el-popover ref="jxspopver" placement="top" width="300" trigger="click">-->
<!--						<div v-if="JXSdata">-->
<!--							<p>上级经销商：{{JXSdata.superior.name}}</p>-->
<!--							<p>国家：{{JXSdata.country}}</p>-->
<!--							<p>省份：{{JXSdata.province}}</p>-->
<!--							<p>联系人：{{JXSdata.contact}}</p>-->
<!--							<p>电话：{{JXSdata.phone}}</p>-->
<!--							<p>邮箱：{{JXSdata.email}}</p>-->
<!--						</div>-->
<!--						<div v-if="!JXSdata">无</div>-->
<!--					</el-popover>-->
<!--					<el-button type="text" v-popover:jxspopver @click="LookDealerDetail(scope.$index,scope.row,scope.column)">{{scope.row.dealer}}</el-button>-->
<!--		    	</template>-->
<!--			</el-table-column>-->
			<el-table-column label="颜色" prop="color" v-if="true"></el-table-column>
			<el-table-column label="版本" width="100" prop="edition" column-key="edition" :filters='VersionFilt'></el-table-column>
			<el-table-column label="设备类别" width="90" prop="type" column-key="type" :filters='TypeFilt'></el-table-column>
			<el-table-column label="软件版本" width="80" prop="software_edition" ></el-table-column>
			<el-table-column label="故障状态" width="90" prop="is_err" column-key="is_err" :filters="ErrorFilt">
				<template slot-scope="scope">
					<span v-if="!scope.row.is_err">正常</span>
		    		<span v-if="scope.row.is_err">
		    			<el-button style="color: red;" type="text" @click="LookErrs(scope.$index,scope.row)">故障</el-button>
		    		</span>
		    	</template>
			</el-table-column>
			<el-table-column label="GPS信号" prop="GPS_signal" width="120"></el-table-column>
			<el-table-column label="基站信号" prop="base_station_signal" width="115">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.base_station_signal">
		    			[{{scope.row.base_station_signal[0]}},{{scope.row.base_station_signal[1]}}]
		    		</span>
			    </template>
			</el-table-column>
			<el-table-column label="电池电量" prop="power" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.power > 40" style="color: green;">{{scope.row.power}}%</span>
		    		<span v-if="scope.row.power <= 40 && scope.row.power > 20" style="color: #ff6600;">{{scope.row.power}}%</span>
		    		<span v-if="scope.row.power <= 20" style="color: red;">{{scope.row.power}}%</span>
			    </template>
			</el-table-column>
			<!--<el-table-column label="配置编号" prop=""></el-table-column>-->
<!--			<el-table-column label="训练状态" width="100" prop="is_training" column-key="is_standing" :filters="TrainingStateFilt">-->
<!--				<template slot-scope="scope">-->
<!--					<span v-if="scope.row.is_training == 1">训练中</span>-->
<!--		    		<span v-if="scope.row.is_training == 0">无</span>-->
<!--			    </template>-->
<!--			</el-table-column>-->
<!--			<el-table-column label="站立状态" width="100" prop="is_standing" column-key="is_standing" :filters="StandStateFilt">-->
<!--				<template slot-scope="scope">-->
<!--					<span v-if="scope.row.is_standing == 1">站立</span>-->
<!--		    		<span v-if="scope.row.is_standing == 2">久站</span>-->
<!--		    		<span v-if="scope.row.is_standing == 0">无</span>-->
<!--			    </template>-->
<!--			</el-table-column>-->
			
			<el-table-column label="开机时长" column-key="running_time" width='120'>
				<template slot-scope="scope">
					<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{timeformat(scope.row.running_time)}}</el-button>	
			    </template>
			</el-table-column>
<!--			<el-table-column label="站立时长" column-key="standing_time">-->
<!--				<template slot-scope="scope">-->
<!--					{{timeformat(scope.row.standing_time)}}-->
<!--					&lt;!&ndash;<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.standing_time}}</el-button>&ndash;&gt;	-->
<!--			    </template>-->
<!--			</el-table-column>-->
			<el-table-column label="速度档位时长">
				<el-table-column label="高档" column-key="high_speed_stage">
		    		<template slot-scope="scope">
		    			{{timeformat(scope.row.speed_stage.high)}}
						<!--<span v-if="scope.row.speed_stage"><el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.speed_stage.high}}</el-button></span>-->	
			    	</template>
		    	</el-table-column>
				<el-table-column label="低档" column-key="low_speed_stage">
					<template slot-scope="scope">
						{{timeformat(scope.row.speed_stage.low)}}
						<!--<span v-if="scope.row.speed_stage"><el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.speed_stage.low}}</el-button></span>-->
			    	</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="运行里程(米)" width="110" column-key="distance">
				<template slot-scope="scope">
					{{scope.row.distance}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.distance}}</el-button>-->	
			    </template>
			</el-table-column>
<!--			<el-table-column label="蹲起(次)" column-key="squat">-->
<!--				<template slot-scope="scope">-->
<!--					{{scope.row.squat}}-->
<!--					&lt;!&ndash;<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.squat}}</el-button>&ndash;&gt;	-->
<!--			    </template>-->
<!--			</el-table-column>-->
<!--			<el-table-column label="训练模式(次)" column-key="training_mode" width="110" >-->
<!--				<template slot-scope="scope">-->
<!--					{{scope.row.training_mode_times}}-->
<!--					&lt;!&ndash;<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.training_mode_times}}</el-button>&ndash;&gt;	-->
<!--			    </template>-->
<!--			</el-table-column>-->
<!--			<el-table-column label="久站提醒(次)" column-key="keep_standing_times" width="110">-->
<!--				<template slot-scope="scope">-->
<!--					{{scope.row.keep_standing_times}}-->
<!--					&lt;!&ndash;<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.keep_standing_times}}</el-button>&ndash;&gt;	-->
<!--			    </template>-->
<!--			</el-table-column>-->
			<!--<el-table-column label="急转提醒(次)" column-key="sharp_turn_times" width="110">
				<template slot-scope="scope">
					<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.sharp_turn_times}}</el-button>	
			    </template>
			</el-table-column>
			<el-table-column label="颠簸提醒" column-key="bump_times">
				<template slot-scope="scope">
					<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.bump_times}}</el-button>	
			    </template>
			</el-table-column>
			<el-table-column label="倾斜提醒" column-key="tilt_times">
				<template slot-scope="scope">
					<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.tilt_times}}</el-button>	
			    </template>
			</el-table-column>-->
			<el-table-column label="颠簸提醒" column-key="sharp_turn_times" width="110">
				<template slot-scope="scope">
					{{scope.row.sharp_turn_times}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.sharp_turn_times}}</el-button>-->	
			    </template>
			</el-table-column>
			<el-table-column label="倾斜提醒" column-key="bump_times">
				<template slot-scope="scope">
					{{scope.row.bump_times}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.bump_times}}</el-button>-->	
			    </template>
			</el-table-column>
			<el-table-column label="急转提醒(次)" column-key="tilt_times">
				<template slot-scope="scope">
					{{scope.row.tilt_times}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.tilt_times}}</el-button>-->	
			    </template>
			</el-table-column>
			<el-table-column label="限速" column-key="speed_limit_times">
				<template slot-scope="scope">
					{{scope.row.speed_limit_times}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.speed_limit_times}}</el-button>-->	
			    </template>
			</el-table-column>
			
			
			<el-table-column label="轮毂电机使用时长" column-key="m_hub">
				<template slot-scope="scope">
					{{timeformat(scope.row.motors_usage.hub_motor)}}
					<!--<span v-if="scope.row.motors_usage"><el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.motors_usage.hub_motor}}</el-button></span>-->	
			    </template>
			</el-table-column>
			<el-table-column label="缠绕电机使用时长" column-key="m_winding">
				<template slot-scope="scope">
					<span v-if="scope.row.motors_usage">
						{{timeformat(scope.row.motors_usage.winding_motor)}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.motors_usage.winding_motor}}</el-button>-->	
			    	</span>
			    </template>
			</el-table-column>
			<el-table-column label="座椅电机使用时长" column-key="m_seat">
				<template slot-scope="scope">
					<span v-if="scope.row.motors_usage">
						{{timeformat(scope.row.motors_usage.seat_motor)}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.motors_usage.seat_motor}}</el-button>-->	
			    	</span>
			    </template>
			</el-table-column>
			<el-table-column label="摆臂电机使用时长" column-key="m_swing_arm">
				<template slot-scope="scope">
					<span v-if="scope.row.motors_usage">
						{{timeformat(scope.row.motors_usage.swing_arm_motor)}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.motors_usage.swing_arm_motor}}</el-button>-->	
			    	</span>
			    </template>
			</el-table-column>
			<el-table-column label="脚踏电机使用时长" column-key="m_swing_foot">
				<template slot-scope="scope">
					<span v-if="scope.row.motors_usage">
						{{timeformat(scope.row.motors_usage.foot_motor)}}
					<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.motors_usage.foot_motor}}</el-button>-->	
			    	</span>
			    </template>
			</el-table-column>
			<el-table-column label="各按键使用次数(次)">
				<el-table-column label="锁定" column-key="b_locked">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.locked}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.locked}}</el-button>-->	
			    		</span>
			    	</template>
				</el-table-column>
				<el-table-column label="开关机" column-key="b_power">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.power}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.power}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
				<el-table-column label="缠绕带in" column-key="b_winding_belt_in">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.winding_belt_in}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.winding_belt_in}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
				<el-table-column label="缠绕带out" column-key="b_winding_belt_out" width="90">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.winding_belt_out}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.winding_belt_out}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
				<el-table-column label="座椅up" column-key="b_seat_up">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.seat_up}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.seat_up}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
				<el-table-column label="座椅down" column-key="b_seat_down" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.seat_down}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.seat_down}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
				<el-table-column label="速度" column-key="b_speed">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.speed}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.speed}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
				<el-table-column label="SOS" column-key="b_SOS">
					<template slot-scope="scope">
						<span v-if="scope.row.buttons">
							{{scope.row.buttons.SOS}}
						<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.buttons.SOS}}</el-button>-->	
						</span>
			    	</template>
				</el-table-column>
			</el-table-column>
			<!--<el-table-column label="镇江驱动器报警" :filters='ZhengJiangFilt' width="90">
				<template slot-scope="scope">
						
			    </template>
			</el-table-column>
			<el-table-column label="主控丢失报警" :filters='ZhuKongLostFilt' width="90">
				<template slot-scope="scope">
						
			    </template>
			</el-table-column>
			<el-table-column label="驱动丢失报警" :filters='QuDongLostFilt' width="90">
				<template slot-scope="scope">
						
			    </template>
			</el-table-column>-->
			<!--<el-table-column label="SOS触发报警" :filters='SOSFilt' width="90">
				<template slot-scope="scope">
						
			    </template>
			</el-table-column>-->
			<!--<el-table-column label="摇杆断线报警" :filters='YaoGanFilt' width="90">
				<template slot-scope="scope">
						
			    </template>
			</el-table-column>
			<el-table-column label="电位器异常报警" :filters='DianWeiQiFilt' width="90">
				<template slot-scope="scope">
						
			    </template>
			</el-table-column>-->
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;"></el-pagination>
		</el-col>
		
		<el-dialog title="设备详情" :visible.sync="DetailVisible" width="90%" top="5%" :before-close="closeEqu">
			<div style="margin: 0 auto;text-align: center;">筛选: <el-date-picker v-model="choosedate" size="mini" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker> 之后的90天  <el-button type="primary" size="mini" icon="el-icon-search" circle @click="nineSearch" ></el-button></div>
			<div id="DetailBox"></div>
		</el-dialog>
		
		<!--<el-dialog :title="loseTitle" :visible.sync="LoseVisible" id="Losedia" :fullscreen="true">
			<div style="display: flex;">
				<el-table border :data="loseOne" v-loading="loseloading">
	      			<el-table-column label="序号" prop="id" width="80">\</el-table-column>
	      			<el-table-column label="丢失时间" prop="e_time" :formatter="dateFormat">\</el-table-column>
	    		</el-table>
	    		<el-table border :data="loseTwo" v-loading="loseloading">
	      			<el-table-column label="序号" prop="id" width="80">\</el-table-column>
	      			<el-table-column label="丢失时间" prop="e_time" :formatter="dateFormat">\</el-table-column>
	    		</el-table>
			</div>
    		
    		<el-col :span="24" class="toolbar">
				<el-pagination layout="prev, pager, next" @current-change="LoseCurrentChange" :page-size="LosePagesize" :current-page="LoseCurpage" :total="Losetotal" style="float:right;">
				</el-pagination>
			</el-col>
		</el-dialog>-->
		
		<el-dialog title="错误详情" :visible.sync="ErrVisible" :fullscreen="true">
			<el-table border :data="ErrList" v-loading="Errloading">
	      		<el-table-column label="mac" prop="mac" width="120">\</el-table-column>
	      		<el-table-column label="版本" prop="e_version" width="80">\</el-table-column>
	      		<el-table-column label="时间" prop="e_time" :formatter="dateFormat" width="160">\</el-table-column>
	      		<el-table-column label="镇江驱动器报警" prop="">
	      			<template slot-scope="scope">
	      				正常
			    	</template>
	      		</el-table-column>
	      		<el-table-column label="主控丢失报警" prop="">
	      			<template slot-scope="scope">
	      				正常
			    	</template>
	      		</el-table-column>
	      		<el-table-column label="驱动丢失报警" prop="">
	      			<template slot-scope="scope">
	      				正常
			    	</template>
	      		</el-table-column>
	      		<el-table-column label="SOS触发报警">
	      			<template slot-scope="scope">
						<span v-if="scope.row.e_type.e6 == 1" style="color: red;">报警</span>
						<span v-if="scope.row.e_type.e6 == 0"></span>
			    	</template>
	      		</el-table-column>
	      		<el-table-column label="摇杆断线报警" prop="">
	      			<template slot-scope="scope">
	      				正常
			    	</template>
	      		</el-table-column>
	      		<el-table-column label="电位器异常报警" prop="">
	      			<template slot-scope="scope">
	      				正常
			    	</template>
	      		</el-table-column>
	    	</el-table>
    		
    		<el-col :span="24" class="toolbar">
				<el-pagination layout="prev, pager, next" @current-change="ErrCurrentChange" :page-size="ErrPagesize" :current-page="ErrCurpage" :total="Errtotal" style="float:right;">
				</el-pagination>
			</el-col>
		</el-dialog>
	</div>
</template>

<script>
	import echarts from 'echarts'
	import moment from 'moment'
	import {CountryFile} from '../common/js/countryFile'
	import {GetDealerlist,GetSportlist,GetSportErrlist,GetSportDevDetail} from '../api/api';
	
	export default {
		data() {
			return {
				choosedate:'',
				detailLoading:true,
				token:"",
				inputWhat:"",
				selectWhat:"",
				maxHeight:600,
				ErrList:[],
				ErrVisible:false,
				Errloading:false,
				ErrPagesize:20,
				ErrCurpage:1,
				Errtotal:1,
				loseTitle:"",
				LoseVisible:false,
				loseOne:[],
				loseTwo:[],
				loseloading:false,
				LosePagesize:40,
				LoseCurpage:1,
				Losetotal:1,
				List:[],
				listloading:false,
				DetailVisible:false,
				Pagesize:20,
				Curpage:1,
				total:20,
				ChooseTime:"",
				TypeTime:"",
				Addoptions:[],
				AddrSelect:[],
				JXSdata:{
					contact:"",
					country:"",
					email:"",
					name:"",
					other:"",
					phone:"",
					province:"",
					superior:{
						id:"",
						name:""
					}
				},
				It:"",
				danwei:"",
				Xmonth:[],
				XData:[],
				Tres:[],
				firstTimeData:[],
				nameList:[
					{
						en:"running_time",
						cn:"开机时长"
					},
					{
						en:"standing_time",
						cn:"站立时长"
					},
					{
						en:"high_speed_stage",
						cn:"高速时长"
					},
					{
						en:"low_speed_stage",
						cn:"低速时长"
					},
					{
						en:"distance",
						cn:"运行里程"
					},
					{
						en:"squat",
						cn:"蹲起次数"
					},
					{
						en:"training_mode",
						cn:"训练模式次数"
					},
//					{
//						en:"squat",
//						cn:"久站提醒次数"
//					},
//					{
//						en:"sharp_turn_times",
//						cn:"急转提醒次数"
//					},
//					{
//						en:"bump_times",
//						cn:"颠簸提醒次数"
//					},
//					{
//						en:"tilt_times",
//						cn:"倾斜提醒次数"
//					},
					
					{
						en:"sharp_turn_times",
						cn:"颠簸提醒次数"
					},
					{
						en:"bump_times",
						cn:"倾斜提醒次数"
					},
					{
						en:"tilt_times",
						cn:"急转提醒次数"
					},
					
					{
						en:"speed_limit_times",
						cn:"限速次数"
					},
					{
						en:"m_hub",
						cn:"轮毂电机使用时长"
					},
					{
						en:"m_winding",
						cn:"缠绕电机使用时长"
					},
					{
						en:"m_seat",
						cn:"座椅电机使用时长"
					},
					{
						en:"m_swing_arm",
						cn:"摆臂电机使用时长"
					},
					{
						en:"m_swing_foot",
						cn:"脚踏电机使用时长"
					},
					{
						en:"b_locked",
						cn:"锁定键次数"
					},
					{
						en:"b_power",
						cn:"开关机键次数"
					},
					{
						en:"b_winding_belt_in",
						cn:"缠绕带in键次数"
					},
					{
						en:"b_winding_belt_out",
						cn:"缠绕带out键次数"
					},
					{
						en:"b_seat_up",
						cn:"座椅up键次数"
					},
					{
						en:"b_seat_down",
						cn:"座椅down键次数"
					},
					{
						en:"b_speed",
						cn:"速度键次数"
					},
					{
						en:"b_SOS",
						cn:"SOS"
					},
				],
				barname:"",
				Seric:[],
				charts:"",
				firstClickData:[],
				VersionFilt:[{text:'运动舒适版',value:'运动舒适版'},{text:'运动基础版',value:'运动基础版'},{text:'运动豪华版',value:'运动豪华版'},{text:'运动工伤版',value:'运动工伤版'},{text:'运动旗舰版',value:'运动旗舰版'}],
				TypeFilt:[{text:'终端客户（个人）',value:'终端客户（个人）'},{text:'经销商客户（购销）',value:'经销商客户（购销）'},{text:'公司内部（市场）',value:'公司内部（市场）'},{text:'终端客户（单位）',value:'终端客户（单位）'},{text:'经销商客户（押金）',value:'经销商客户（押金）'},{text:'公司内部（研发）',value:'公司内部（研发）'},{text:'其他',value:'其他'}],
				ErrorFilt:[{text:'故障',value:true},{text:'正常',value:false}],
				StandStateFilt:[{text:'站立',value:1},{text:'久站',value:2},{text:'无',value:0}],
				TrainingStateFilt:[{text:'训练中',value:1},{text:'无',value:0}],
				ZhengJiangFilt:[{text:'故障',value:'1'},{text:'正常',value:'0'}],
				ZhuKongLostFilt:[{text:'故障',value:'1'},{text:'正常',value:'0'}],
				QuDongLostFilt:[{text:'故障',value:'1'},{text:'正常',value:'0'}],
				SOSFilt:[{text:'故障',value:'1'},{text:'正常',value:'0'}],
				YaoGanFilt:[{text:'故障',value:'1'},{text:'正常',value:'0'}],
				DianWeiQiFilt:[{text:'故障',value:'1'},{text:'正常',value:'0'}],
				Form:{
					mac:""
				},
				thmac:"",
				thtype:"",
				Choice:[
					{name:"开机时长",val:1,oten:"running_time"},
					{name:"站立时长",val:2,oten:"standing_time"},
					{name:"速度高档时长",val:3,oten:"speed_stage.high"},
					{name:"速度低档时长",val:4,oten:"speed_stage.low"},
					{name:"运行里程",val:5,oten:"distance"},
					{name:"蹲起次数",val:6,oten:"squat"},
					{name:"训练模式次数",val:7,oten:"training_mode_times"},
//					{name:"久站提醒次数",val:8,oten:"swing_arm.angled"},
//					{name:"急转提醒次数",val:9,oten:"sharp_turn_times"},
//					{name:"颠簸提醒次数",val:10,oten:"bump_times"},
//					{name:"倾斜提醒次数",val:11,oten:"tilt_times"},
					
					{name:"颠簸提醒次数",val:9,oten:"sharp_turn_times"},
					{name:"倾斜提醒次数",val:10,oten:"bump_times"},
					{name:"急转提醒次数",val:11,oten:"tilt_times"},
					
					{name:"限速次数",val:12,oten:"speed_limit_times"},
					{name:"轮毂电机使用时长",val:13,oten:"motors_usage.hub_motor"},
					{name:"缠绕电机使用时长",val:14,oten:"motors_usage.winding_motor"},
					{name:"座椅电机使用时长",val:15,oten:"motors_usage.seat_motor"},
					{name:"摆臂电机使用时长",val:16,oten:"motors_usage.swing_arm_motor"},
					{name:"脚踏电机使用时长",val:17,oten:"motors_usage.foot_motor"},
					{name:"锁定键次数",val:18,oten:"buttons.locked"},
					{name:"开关机键次数",val:19,oten:"buttons.power"},
					{name:"缠绕带in键次数",val:20,oten:"buttons.winding_belt_in"},
					{name:"缠绕带out键次数",val:21,oten:"buttons.winding_belt_out"},
					{name:"座椅up键次数",val:22,oten:"buttons.seat_up"},
					{name:"座椅down键次数",val:23,oten:"buttons.seat_down"},
					{name:"速度键次数",val:24,oten:"buttons.speed"},
					{name:"SOS键次数",val:25,oten:"buttons.SOS"},
				],
				selectMore:"",
				input1:"",
				input2:"",
				betweenData:[],
				dynamicTags:[],
				Screenall:{},
				lastAll:{},
				Betweenall:{},
				ChooseJxs:[],
				JXSareaList:[],
				chooseJxs:[],
				startTime: 0,
				categories: [],
				finaldata:[],
				newObj:[],
				which:{}
			}
		},
		methods:{
			timeformat(val){
				var mint = Math.round(val/60)%60
				var hour = (Math.round(val/60) - Math.round(val/60)%60)/60
				if(mint == 0 && hour == 0){
					return 0 + "分钟"
				}else if(hour == 0){
					return mint + "分钟"
				}else if(mint == 0 ){
					return hour + "小时"
				}else{
					return hour + "小时" + mint + "分钟"
				}
			},
			changeJxs(){
				console.log(this.chooseJxs[1])
				if(this.lastAll.dealer){
					for(var j=0;j<this.lastAll.dealer.length;j++){
						if(this.lastAll.dealer[j].indexOf(this.chooseJxs[1]) != -1){
							this.lastAll.dealer.splice(j,1)
						}
					}
					this.lastAll.dealer.push(this.chooseJxs[1])
				}else{
					this.lastAll.dealer = [this.chooseJxs[1]]
				}
				console.log("lastAll",this.lastAll)
				
				for(var i=0;i<this.dynamicTags.length;i++){
						if(this.dynamicTags[i].indexOf(this.chooseJxs[1]) != -1){
							this.dynamicTags.splice(i,1)
						}
					}
			    this.dynamicTags.push(this.chooseJxs[1]);
				this.chooseJxs = []
			},
			handleInputConfirm(){
				var that = this
				var selectedText = ""
				if(that.selectMore && that.input1 && that.input2){
					for(var i=0;i<this.Choice.length;i++){
						if(this.Choice[i].val == this.selectMore){
							selectedText = this.Choice[i].name
							if(parseInt(that.input1) < parseInt(that.input2)){
								that.betweenData[this.Choice[i].oten] = [parseInt(that.input1),parseInt(that.input2)]
							}else if(parseInt(that.input1) > parseInt(that.input2)){
								that.betweenData[this.Choice[i].oten] = [parseInt(that.input2),parseInt(that.input1)]
							}
						}
					}
					
					let inputValue = selectedText + ":" + this.input1 +"至"+ this.input2;
					for(var i=0;i<this.dynamicTags.length;i++){
						if(this.dynamicTags[i].indexOf(selectedText) != -1){
							this.dynamicTags.splice(i,1)
						}
					}
			        
			        if (inputValue) {
			        	this.dynamicTags.push(inputValue);
			        }
			        this.selectMore = ""
			        this.input1 = ""
			        this.input2 = ""
				}else{
					this.$message.error("请将筛选条件填写完整。")
				}
			},
			handleClose(tag){
		   		var that = this
		   		for(var i=0;i<this.Choice.length;i++){
		   			if(tag.indexOf(this.Choice[i].name) >= 0){
		   				delete that.betweenData[this.Choice[i].oten]
		   			}
		   		}
		   		
		   		for(var j=0;j<this.lastAll.dealer.length;j++){
		   			if(this.lastAll.dealer[j] == tag){
		   				var index = this.lastAll.dealer.indexOf(tag)
		   				this.lastAll.dealer.splice(index,1)
		   			}
		   		}
				console.log("this.lastAll",this.lastAll)		   		
		   		this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		   		if(JSON.stringify(that.betweenData) == '{}'){
		   			this.Quickfind()
		   		}
		   	},
		   	Filterfind(filters){
		   		console.log(filters)
				var that = this
				for(var item in filters){
					if(filters[item]){
						that.lastAll[item] = filters[item]
					}
				}
				console.log("that.lastAll",that.lastAll)
				this.Quickfind()
			},
			clearIDmac(){
				this.selectWhat = ""
				this.inputWhat = ""
				this.lastAll.did = ""
				this.lastAll.mac = ""
			},
		   	Quickfind(){
		   		var that = this
					that.Screenall = {}
					
					if(that.selectWhat == 1 && that.inputWhat){
						that.lastAll.did = "~" + that.inputWhat
						that.lastAll.mac = ""
					}
					if(that.selectWhat == 2 && that.inputWhat){
						that.lastAll.mac = "~" + that.inputWhat
						that.lastAll.did = ""
					}
					
					for(var i in that.lastAll){
						if(that.lastAll[i] && that.lastAll[i].length > 0){
							that.Screenall[i] = that.lastAll[i]
							}
					}
					console.log("Screenall",JSON.stringify(that.Screenall))
					
					that.Betweenall = {}
					
					if(that.TypeTime == 1 && that.ChooseTime){
						that.betweenData.delivery_date = [that.ChooseTime[0]/1000,that.ChooseTime[1]/1000 + 86399]
						that.betweenData.sales_date =[]
					}
					if(that.TypeTime == 2 && that.ChooseTime){
						that.betweenData.sales_date = [that.ChooseTime[0]/1000,that.ChooseTime[1]/1000 + 86399]
						that.betweenData.delivery_date =[]
					}
					
					for(var i in that.betweenData){
						if(that.betweenData[i] && that.betweenData[i].length > 0){
							that.Betweenall[i] = that.betweenData[i]
							}
					}
					console.log("Betweenall",JSON.stringify(that.Betweenall))
					
					var qeach = JSON.stringify([{"AND":that.Screenall},{"BETWEEN":this.Betweenall}])
					console.log(qeach)
					
					if(that.Screenall || that.Betweenall){
						this.GetList(GetSportlist,{page:this.Curpage,token:this.token,q:qeach,sort:'-delivery_date'})
					}else{
						this.GetList(GetSportlist,{page:this.Curpage,token:this.token,sort:'-delivery_date'})
					}
		   	},
			handleCurrentChange(val){
				this.Curpage = val
				console.log("lbf",val)
				this.Quickfind()
			},
			SelectChange(value){
				console.log(value)
				this.lastAll.address = value
			},
			tableRowClassName(row){
				if(row.row.is_err){
					if(row.row.is_err == 1){
						return 'warning-row';
					}else {
						return ''
					}
				}else {
					return ''
				}
			},
			addformat(row,column){
				var add = row[column.property]
				if(add){
					if(add[0] == "无"){
						return "无"
					}else if(add[0] == add[1]){
						return add[1] + add[2] + add[3]
					}else{
						return add[0] + add[1] + add[2] + add[3]
					}
				}else{
					return "无"
				}
			},
			addformat2(row,column){
				var add = row[column.property]
				if(add){
					if(add[0] == "无"){
						return "无"
					}else if(add[0] == add[1]){
						return add[0]
					}else{
						return add[0] + add[1]
					}
				}else{
					return "无"
				}
			},
			LookErrs(index,row){
				
				var thisErr = Object.assign({}, row)
				this.Errmac = thisErr.mac
				this.ErrVisible = true
				this.GetSportErrlist()
			},
			ErrCurrentChange(val){
				this.ErrCurpage = val
			},
			GetSportErrlist(){
				this.Errloading = true
				let param = {
					token:this.token,
					perPage:this.ErrPagesize,
					page:this.ErrCurpage,
					q:JSON.stringify([{"AND":{'mac':this.Errmac}}])
				}
				GetSportErrlist(param).then(res => {
					console.log(res)
					this.ErrList = res.data.items
					this.Errtotal = res.data.meta.totalCount
					this.Errloading = false
				}).catch(err => {
					this.$message.error(err)
					this.Errloading = false
				})
			},
			LookDealerDetail(index,row,column){
				var that = this
				var which = Object.assign({}, row);
//				console.log(which.dealer)
				
				var par = {
					token:this.token,
					q:JSON.stringify([{"AND":{"name":'~' + which.dealer}}])
				}
				GetDealerlist(par).then(res => {
//					console.log(res)
					if(res.data.items){
						that.JXSdata = res.data.items[0]
					}else{
						this.$message.error('对不起，经销商信息获取失败。')
					}
				}).catch(err => {
					this.$message.error(err)
				})
			},
			dateFormate(date){
				var a = date*1000
				var time = new Date(a)
				var h = time.getHours();
				var mm = time.getMinutes();
				var s = time.getSeconds();
				var last = h*3600 + mm*60 + s
				return last
			},
			useDate(val){
				var s = val % 60
				var m = parseInt(val/60)%60
				var h = parseInt(parseInt(val/60)/60)
				if(h == 0){
					return m + '分'+ s+'秒'
				}else if(h == 0 && m == 0){
					return s + '秒'
				}else{
					return h +'小时'+ m+ '分'+ s+'秒' 
				}
			},
			LookDetail(index,row,column){
				var that = this
				this.DetailVisible = true
				this.It = column.columnKey
				this.which = Object.assign({}, row);
//				一个月前的第一天0点
				var lastM_start = parseInt(new Date(new Date(new Date().toLocaleDateString()).setMonth(new Date().getMonth()-3)).getTime()/1000);
//				昨晚23：59：59
				var yes_endDate = parseInt(new Date(new Date(new Date(new Date().setDate(new Date().getDate()-1)).toLocaleDateString()).getTime()+24*60*60*1000-1).getTime()/1000);
//				this.DetailVisible = true
				this.getdata(that.which.did,lastM_start,yes_endDate,90)
			},
			nineSearch(){
					var that = this
					this.finaldata = []
					this.newObj = []
					this.Seric = []
					this.charts.dispose()
				if(this.choosedate){
					var startDate = parseInt(this.choosedate/1000)
					var endDate = parseInt(startDate + 86400*91-1 )
					this.getdata(that.which.did,startDate,endDate,90)
				}else{
//				一个月前的第一天0点
				var lastM_start = parseInt(new Date(new Date(new Date().toLocaleDateString()).setMonth(new Date().getMonth()-1)).getTime()/1000);
//				昨晚23：59：59
				var yes_endDate = parseInt(new Date(new Date(new Date(new Date().setDate(new Date().getDate()-1)).toLocaleDateString()).getTime()+24*60*60*1000-1).getTime()/1000);
//				this.DetailVisible = true
				this.getdata(that.which.did,lastM_start,yes_endDate,90)
				}
			},
//			请求接口数据
			getdata(did,starttime,endtime,days){
				var that = this
				
				var newdata = []
				var allLast = []
				var condit = [{"AND":{"did":did}},{"BETWEEN":{"date":[starttime,endtime]}}]
				var condit2 = JSON.stringify(condit)
				
				var param = {
					page:1,
					token:that.token,
					perPage:50,
					q:condit2
				}
				
				GetSportDevDetail(param).then(res => {
					newdata = res.data.items
					var allcount = res.data.meta.pageCount
					if(allcount > 1){
							var para = {
								page:2,
								token:that.token,
								perPage:50,
								q:condit2
							}
							GetSportDevDetail(para).then(res => {
								Array.prototype.push.apply(newdata, res.data.items);
//								获取y轴yline
								var yline = []
								for(var i=0;i<days;i++){
									var ttt = starttime + 86400*i
									yline.push(moment(ttt*1000).format("MM/DD"))
									
									allLast[i] = {}
									allLast[i].dalydate = yline[i]
								}
								
								
								for(var m=0;m<allLast.length;m++){
									allLast[m].dur = []
									for(var n=0;n<newdata.length;n++){
										if(allLast[m].dalydate == moment(newdata[n].date*1000).format("MM/DD")){
											for(var j=0;j<newdata[n].records.length;j++){
												var arr = []
												arr.push(newdata[n].records[j].turn_on_at) 
												arr.push(newdata[n].records[j].turn_off_at)
												arr.push(newdata[n].records[j].mileage)
												arr.push(newdata[n].records[j].squat)
												allLast[m].dur[j] = arr
											}
										}
									}
								}
								
								that.categories = []
								that.newObj = allLast
								
								for(var i in that.newObj){
									that.categories.push(that.newObj[i].dalydate)
								}

								that.datafor()
								
//								获取完数据画图
								that.$nextTick(function() {
							        that.DrawPie()
							    })
							}).catch(err => {
								console.log(err)
							})
					}else{
						
//					获取y轴yline
					var yline = []
					for(var i=0;i<days;i++){
						var ttt = starttime + 86400*i
						yline.push(moment(ttt*1000).format("MM/DD"))
						
						allLast[i] = {}
						allLast[i].dalydate = yline[i]
					}

						console.log('lbf111',allLast);
					
					for(var m=0;m<allLast.length;m++){
						allLast[m].dur = []
						for(var n=0;n<newdata.length;n++){
							if(allLast[m].dalydate == moment(newdata[n].date*1000).format("MM/DD")){
								for(var j=0;j<newdata[n].records.length;j++){
									var arr = []
									arr.push(newdata[n].records[j].turn_on_at) 
									arr.push(newdata[n].records[j].turn_off_at)
									arr.push(newdata[n].records[j].mileage)
									arr.push(newdata[n].records[j].squat)
									allLast[m].dur[j] = arr
								}
							}
						}
					}
						console.log('lbf222',allLast);
					
					that.categories = []
					that.newObj = allLast

						console.log('lbf333',that.newObj);

					for(var i in that.newObj){
						that.categories.push(that.newObj[i].dalydate)
					}

						console.log('lbf444',that.categories);
					that.datafor()
					
//				获取完数据画图
						that.$nextTick(function() {
				            that.DrawPie()
				        })
					}
				}).catch(err => {
					console.log('err',err)
				})
				
			},
			datafor(){
				var that = this
				echarts.util.each(that.categories, function(category, index) {
					var baseTime = that.newObj[index].dur;
					var toptime = that.newObj[index].dalydate
					if(baseTime.length == 0){
						that.finaldata.push({
									name: '使用时长',
									value: [
										index,
										'0',
										'0',
										'0',
										'0',
										'0',
										toptime
									],
									itemStyle: {
										normal: {
											color: '#7b9ce1'
										}
									}
								});
					}else{
					for(var i = 0; i < baseTime.length; i++) {
//						console.log(123)
						if(baseTime[i].length > 1){
							that.finaldata.push({
								name: '使用时长',
								value: [
									index,
									that.dateFormate(baseTime[i][0]),
									that.dateFormate(baseTime[i][1]),
									that.dateFormate(baseTime[i][1]) - that.dateFormate(baseTime[i][0]),
									baseTime[i][2],
									baseTime[i][3],
									toptime
								],
								itemStyle: {
									normal: {
										color: '#7b9ce1'
									}
								}
							});
						}else{
							console.log(baseTime[i])
							that.finaldata.push({
								name: '使用时长',
								value: [
									index,
									'0',
									'0',
									'0',
									'0',
									'0',
									toptime
								],
								itemStyle: {
									normal: {
										color: '#7b9ce1'
									}
								}
							});
						}
						}
					}
				});
//				console.log('that.finaldata',that.finaldata)
				that.Seric = [
					{
						type: 'custom',
						renderItem: that.renderItem,
						itemStyle: {
							normal: {
								opacity: 0.8
							}
						},
						encode: {
							x: [1, 2],
							y: 0
						},
						data: that.finaldata
					}
				]
				
			},
			renderItem(params, api) {
				var categoryIndex = api.value(0);
				var start = api.coord([api.value(1), categoryIndex]);
				var end = api.coord([api.value(2), categoryIndex]);
				var height = api.size([0, 1])[1] * 0.6;
				var rectShape = echarts.graphic.clipRectByRect({
					x: start[0],
					y: start[1] - height / 2,
					width: end[0] - start[0],
					height: height
				}, {
					x: params.coordSys.x,
					y: params.coordSys.y,
					width: params.coordSys.width,
					height: params.coordSys.height
				});
				
				return rectShape && {
					type: 'rect',
					shape: rectShape,
					style: api.style()
				};
			},
			opt(){
				var that = this
				for(var i=0;i<that.nameList.length;i++){
					if(that.nameList[i].en == that.It){
						that.barname = that.nameList[i].cn
					}
				}
				
				
				that.charts.setOption({
					tooltip: {
						formatter: function(params) {
							var start = params.value[1]
							var end = params.value[2]
							var sformate = (parseInt(start/3600) + '') + ':' + (parseInt((start%3600)/60) + '')
							var eformate = (parseInt(end/3600) + '') + ':' + (parseInt((end%3600)/60) + '')
							var omas = params.data.othermas
//							for(var key in omas) {
//      						console.log(key)
//      						return key + ': ' + omas[key] + ' ms'
//							}
							return params.value[6] + '   ' + sformate + '-' + eformate + '</br>'  + '使用' + ': ' + that.useDate(params.value[3])+ '</br>' + '行驶：' + params.value[4] + '米' + '</br>' + '蹲起：'+params.value[5] + '次'
						}
					},
//					title: {
//						text: that.barname,
//						left: 'center'
//					},
//					grid: {
//						height: 800
//					},
					xAxis: {
						type:'time',
						boundaryGap: false,
						min: that.startTime,
						max:86400,
						interval:3600,
						axisLabel: {
							formatter: function(val) {
								return val/3600 + ':00'
//								return val
							}
						}
					},
					yAxis: {
						data: that.categories
					},
					series: that.Seric
				})
			},
			
			
			closeEqu(){
				this.finaldata = []
				this.newObj = []
				this.Seric = []
				this.choosedate = ''
				this.charts.dispose()
				this.DetailVisible = false
			},
			DrawPie(){
				var that = this
				that.charts = echarts.init(document.getElementById('DetailBox'))
				that.opt()
			},

			Refresh(){
				location.reload();
			},
			GetDealer(){
				var that = this
				let param = {
					token:this.token,
					fields:"id,name,province",
					perPage:50,
				}
				GetDealerlist(param).then(res => {
//					console.log(res)
					var JxsList = []
					var getDealer = res.data.items
					var arr = []
					for(var i=0;i<getDealer.length;i++){
						if(getDealer[i].province != " "){
							arr.push(getDealer[i].province)
						}
					}
//					console.log("arr",arr)
					var result = []
					for(var m=0;m<arr.length;m++){
						for(var n=m+1;n<arr.length;n++){
							if(arr[m] == arr[n]){
								n = ++m
							}
						}
						result.push(arr[m]);
					}
//					console.log("result",result)
					for(var k=0;k<result.length;k++){
						JxsList[k] = {}
						JxsList[k].label = result[k]
						JxsList[k].value = result[k]
						JxsList[k].children = []
					}
//					console.log("JxsList",JxsList)

					for(var a=0;a<JxsList.length;a++){
						for(var b=0;b<getDealer.length;b++){
							if(JxsList[a].label == getDealer[b].province){
								JxsList[a].children.push(getDealer[b].name)
							}
						}
					}
//					console.log(JxsList)
					for(var i=0;i<JxsList.length;i++){
						that.JXSareaList[i] = {}
						that.JXSareaList[i].label = JxsList[i].label
						that.JXSareaList[i].value = JxsList[i].value
						that.JXSareaList[i].children = []
						for(var j=0;j<JxsList[i].children.length;j++){
							that.JXSareaList[i].children[j] = {}
							that.JXSareaList[i].children[j].label = JxsList[i].children[j]
							that.JXSareaList[i].children[j].value = JxsList[i].children[j]
						}
					}
//					console.log("that.JXSareaList",that.JXSareaList)
				}).catch(err => {
					console.log(err)
				})
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Addoptions = CountryFile			
			this.GetDealer()
			this.GetList(GetSportlist,{page:this.Curpage,token:this.token,sort:'-delivery_date'})
			
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}
</script>

<style>
#SportTableBox .warning-row {
    background: #ffeeee;
  }

#SportTableBox .successRow {
    background: #f0f9eb;
  }
#DetailBox {
	width: 100%;
	height: 700px;
}
.el-select{
		width: 100px;
	}
</style>


// WEBPACK FOOTER //
// SportEquipment.vue?380967c8